import React from "react";
import Box from "../Box";
import styled from "styled-components";
import { CText, CButton } from "@carrefour/design-system-components-react";
import { useTranslation } from "react-i18next";

const Text = styled(CText)`
  font-family: system-ui;
`;

type ForbiddenPageProps = {
  logout: () => void;
};
const ForbiddenPage = ({ logout }: ForbiddenPageProps) => {
  const {t} = useTranslation();
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"100vh"}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        mb={8}
        p={1}
        style={{ gap: "8px" }}
      >
        <Text size={"l"} style={{ fontFamily: "system-ui" }}>
          {
            t('common.msg_non_authorise')
          }
        </Text>
        <CButton
          size="s"
          tone={"main"}
          variation={"primary"}
          onClick={() => logout()}
        >
          {t('common.se_deconnecter')}
        </CButton>
      </Box>
    </Box>
  );
};

export default ForbiddenPage;
